import { TypePolicy } from '@apollo/client'
export const projectProductFamilyTypePolicy = {
    ProjectProductFamily: {
        keyFields: ['id'],
    } as TypePolicy,
}
